<template>
    <div class="relative bg-white px-4 sm:px-8 py-6 sm:py-10 rounded-sm shadow border border-slate-300">

        <div class="absolute top-0 left-0 max-w-full -translate-y-1/2 -translate-x-2 overflow-hidden">
            <svg width="800" height="14" viewBox="0 0 800 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 6L555 6.00005" stroke="#F8FAFC" stroke-width="12" stroke-linecap="round" stroke-dasharray="0.01 26"/><g clip-path="url(#clip0_967_3688)"><g filter="url(#filter0_i_967_3688)"><path d="M21 6L755 6.00005" stroke="#F8FAFC" stroke-width="12" stroke-linecap="round" stroke-dasharray="0.01 26"/></g></g><defs><filter id="filter0_i_967_3688" x="15" y="-1" width="800" height="13.0001" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="-1"/><feGaussianBlur stdDeviation="0.5"/><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/><feBlend mode="normal" in2="shape" result="effect1_innerShadow_967_3688"/></filter><clipPath id="clip0_967_3688"><rect width="800" height="8" fill="white" transform="translate(0 6)"/></clipPath></defs></svg>
        </div>

        <div v-for="item in invoice.lines?.data || []" :key="item.id" class="mb-3 flex justify-between place-items-baseline gap-6 sm:gap-1 text-sm sm:text-base">
            <div class="text-slate-500 sm:text-slate-900">{{ item.description }}</div>
            <div class="hidden sm:flex grow border-b border-dashed border-0 border-slate-300"></div>
            <div>{{ currencyCents(item.amount) }}</div>
        </div>

        <div class="sm:hidden mt-6 border-b border-y-0 border-slate-300 border-dashed"></div>

        <div v-if="invoice.subtotal !== invoice.total" class="mt-6 flex justify-between place-items-baseline gap-6 sm:gap-1 font-bold">
            <div>Subtotal</div>
            <div class="hidden sm:flex grow border-b border-dashed border-0 border-slate-300"></div>
            <div>{{ currencyCents(invoice.subtotal) }}</div>
        </div>

        <div v-if="invoice.tax" class="mt-3 flex justify-between place-items-baseline gap-6 sm:gap-1 text-sm sm:text-base">
            <div class="text-slate-500 sm:text-slate-900">Tax</div>
            <div class="hidden sm:flex grow border-b border-dashed border-0 border-slate-300"></div>
            <div>{{ currencyCents(invoice.tax) }}</div>
        </div>

        <div v-for="discount in invoice.total_discount_amounts || []" :key="discount.amount" class="mt-3 flex justify-between place-items-baseline gap-6 sm:gap-1 text-sm sm:text-base">
            <div class="text-slate-500 sm:text-slate-900">Discount</div>
            <div class="hidden sm:flex grow border-b border-dashed border-0 border-slate-300"></div>
            <div>-{{ currencyCents(discount.amount) }}</div>
        </div>

        <div class="mt-6 flex justify-between place-items-baseline gap-6 sm:gap-1 font-bold">
            <div>Total</div>
            <div class="hidden sm:flex grow border-b border-dashed border-0 border-slate-300"></div>
            <div>{{ currencyCents(invoice.total) }}</div>
        </div>

        <div class="sm:hidden mt-6 border-b border-y-0 border-slate-300 border-dashed"></div>

        <div class="mt-6 flex justify-between sm:justify-normal gap-2 items-center text-xs text-slate-500">
            <div>Next bill:</div>
            <vx-badge color="amber" size="xs">
                {{ date(invoice.period_end * 1000) }}
            </vx-badge>
        </div>

        <div class="absolute bottom-0 left-0 max-w-full translate-y-1/2 -translate-x-2 overflow-hidden">
            <svg width="800" height="13" viewBox="0 0 800 13" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_i_967_4268)"><path d="M21 7L855 7.00005" stroke="#F8FAFC" stroke-width="12" stroke-linecap="round" stroke-dasharray="0.01 26" /></g><defs><filter id="filter0_i_967_4268" x="15" y="1" width="800" height="13" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix" /><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" /><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" /><feOffset dy="1" /><feGaussianBlur stdDeviation="0.5" /><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" /><feColorMatrix type="matrix" values="0 0 0 0 0.135116 0 0 0 0 0.239299 0 0 0 0 0.358366 0 0 0 0.15 0" /><feBlend mode="normal" in2="shape" result="effect1_innerShadow_967_4268" /></filter></defs></svg>
        </div>

    </div>
</template>

<script setup>
import { VxBadge } from '@voxie/frontend-components';
import { currencyCents, date } from '~/utils/helpers';

defineProps({
    // Stripe invoice object
    invoice: {
        type: Object
    },
});
</script>
